import Decimal from 'decimal.js';
import { useWatch } from 'react-hook-form';

import { HelpTextVariant } from '@/components/form/baseInputs/inputTypes';
import { useFormContext } from '@/components/react-hook-form';
import { InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery } from '@/modules/entities/InsurancePolicyDetailsSubform/graphql/InsurancePolicyDetailsPremiumPaymentSourceOptions.generated';
import { getTransferSourceValueHelpText } from '@/modules/estateWaterfall/components/EstateWaterfallHypotheticalTransfers/estateWaterfallHypotheticalTransfers.utils';
import { getNodes } from '@/utils/graphqlUtils';

import {
  HypotheticalILITFormModalShape,
  HypotheticalILITFormModalShapePaths,
} from '../HypotheticalILITModal.types';

export function useTransferHelpText(
  queryData: InsurancePolicyDetailsPremiumPaymentSourceOptionsQuery | undefined
): {
  helpText: string | undefined;
  helpTextVariant?: HelpTextVariant | undefined;
} {
  const { control } = useFormContext<HypotheticalILITFormModalShape>();
  const [transferFromId, transferValue] = useWatch({
    control,
    name: [
      'transferFromId' as const satisfies HypotheticalILITFormModalShapePaths,
      'transferValue' as const satisfies HypotheticalILITFormModalShapePaths,
    ],
  });

  if (!queryData) {
    return { helpText: undefined };
  }

  const entity = getNodes(queryData.entities).find(
    (entity) => entity.id === transferFromId
  );

  if (!entity) {
    return { helpText: undefined };
  }

  const sourceValue = entity.subtype.currentValue || new Decimal(0);

  return getTransferSourceValueHelpText(
    sourceValue,
    transferValue?.greaterThan(sourceValue)
  );
}
